/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: bbqin
 * @LastEditTime: 2022-03-26 16:29:54
 * @Description: file content
 */
import React, { Component } from 'react';
// import OriginStep from 'bee-step';
import { Steps as OriginSteps } from "@tinper/next-ui";
const { Step: OriginStep } = OriginSteps;
require('./index.less');
export default class Step extends Component {
    render() {
        let { className = '' } = this.props;
        return <OriginStep {...this.props} className={className + ' base-step '} />;
    }
}

Step.Steps = OriginSteps;
